import moment from 'moment';
import mapListSort from '../utils';

const initialState = {
  detailModalId: null,
  agentSentimentModalId: null,
  callerSentimentModalId: null,
  scriptModalId: null,
  adherenceModalOpen: false,
  agentSentimentPerformanceModalOpen: false,
  callerSentimentPerformanceModalOpen: false,
  callFilterOpen: false,
  loading: false,

  records: [],
  recordBook: [],
  recordPageIdx: 0,
  recordPageCount: 0,
  recordPageSize: 0,

  searchTerm: '',
  agencyFilter: '',
  selectedAgents: [],
  allSelectCheck: false,
  initialSelect: true,
  headerAgency: null,
};

const defaultSort = 'enrollment_date';
const initialFilterState = {
  sortTerm: defaultSort,
  sortInverse: true,
  stCallStartDate: moment().startOf('day').subtract(1, 'year').toISOString(),
  stCallEndDate: moment().endOf('day').toISOString(),
  stEnrollmentStartDate: null,
  stEnrollmentEndDate: null,
  stEnrollmentId: '',
  stEnrollmentStatus: 'any',
  stClientLastName: '',
  stClientFirstName: '',
  stClientPhone: '',
  stLeadId: '',
  stAgentFirstName: '',
  stAgentLastName: '',
  stAgentNPN: '',
  stCarrier: '',
  stPlanType: '',
  stPlanCarrier: '',
  stAgentSentiment: 'any',
  stCallerSentiment: 'any',
  stAgency: 'any',
  stAdherence: 'any',
};

// Used to hide/show a given column on script adherence table
const columnFilters = [
  { id: 'sentiment', label: 'Sentiment', value: true },
  { id: 'sentiment-agent', label: 'Agent', value: true },
  { id: 'sentiment-client', label: 'Client', value: true },
  { id: 'callinfo', label: 'Call info', value: true },
  { id: 'callinfo-starttime', label: 'Start time', value: true },
  { id: 'callinfo-duration', label: 'Duration', value: true },
  { id: 'callinfo-type', label: 'Type', value: true },
  { id: 'scriptadherence', label: 'Script adherence', value: true },
  { id: 'scriptadherence-confidence', label: 'Confidence', value: true },
  { id: 'scriptadherence-overall', label: 'Overall', value: true },
  { id: 'scriptadherence-acknowledge', label: 'Acknowledge', value: true },
  { id: 'scriptadherence-contact', label: 'Contact', value: true },
  { id: 'scriptadherence-medicare', label: 'Medicare', value: true },
  { id: 'scriptadherence-eligibility', label: 'Eligibility', value: true },
  { id: 'scriptadherence-payment', label: 'Payment', value: true },
  { id: 'scriptadherence-attest', label: 'Attest', value: true },
  { id: 'enrollment', label: 'Enrollment', value: true },
  { id: 'enrollment-status', label: 'Status', value: true },
  { id: 'enrollment-lastupdated', label: 'Last updated', value: true },
  { id: 'enrollment-id', label: 'ID', value: true },
];

export default (state = {
  ...initialState,
  ...initialFilterState,
  columnFilters,
}, action) => {
  switch (action.type) {
    case 'UPDATE_RECORDS_HEADER':
      return { ...state, headerAgency: action.agency };
    case 'TOGGLE_RECORD_DETAIL':
      return { ...state, detailModalId: action.id };
    case 'TOGGLE_RECORD_AGENT_SENTIMENT':
      return { ...state, agentSentimentModalId: action.id };
    case 'TOGGLE_RECORD_CALLER_SENTIMENT':
      return { ...state, callerSentimentModalId: action.id };
    case 'TOGGLE_RECORD_SCRIPT':
      return { ...state, scriptModalId: action.id };
    case 'TOGGLE_ADHERENCE_MODAL':
      return { ...state, adherenceModalOpen: !state.adherenceModalOpen };
    case 'TOGGLE_RECORD_AGENT_SENTIMENT_PERFORMANCE_MODAL':
      return {
        ...state,
        agentSentimentPerformanceModalOpen: !state.agentSentimentPerformanceModalOpen,
      };
    case 'TOGGLE_RECORD_CALLER_SENTIMENT_PERFORMANCE_MODAL':
      return {
        ...state,
        callerSentimentPerformanceModalOpen: !state.callerSentimentPerformanceModalOpen,
      };
    case 'SET_INITIAL_SELECT':
      return { ...state, initialSelect: action.payload };
    case 'SET_RECORD_SORT_TERM':
      /* eslint-disable no-case-declarations */
      const newSortTerm = action.payload ? action.payload : defaultSort;
      return { ...state, sortTerm: newSortTerm };
      /* eslint-enable no-case-declarations */
    case 'CLEAR_RECORD_SORT_TERM':
      return { ...state, sortTerm: defaultSort };
    case 'SET_RECORD_SORT_INVERSE':
      return { ...state, sortInverse: action.payload };
    case 'CLEAR_RECORD_SORT_INVERSE':
      return { ...state, sortInverse: false };
    case 'SET_SEARCH_TERM':
      return { ...state, [action.name]: action.value };
    case 'CLEAR_SEARCH_TERM':
      return { ...state, ...initialFilterState };
    case 'SET_ACTIVE_STATUS': {
      const selectedAgents = state.selectedAgents
        .map((agent) => ({ ...agent, is_active: action.payload }));
      return { ...state, selectedAgents };
    }
    case 'SET_RECORDS_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_ALL_SELECT_CHECKBOX':
      return { ...state, allSelectCheck: action.payload };
    case 'CLEAR_SELECTED_AGENTS':
      return { ...state, selectedAgents: [] };
    case 'ADD_SELECTED_AGENT': {
      const selectedAgents = [...state.selectedAgents];
      selectedAgents.push(action.payload);
      return { ...state, selectedAgents };
    }
    case 'DESELECT_ALL_AGENTS': {
      const selectedAgents = Array.from(
        new Set([...state.selectedAgents].map((a) => a.contact_id)),
      );
      const agentsToRemove = Array.from(new Set(action.payload.map((a) => a.contact_id)));
      const newAgentsList = [];
      selectedAgents.forEach((contactid) => {
        if (!agentsToRemove.includes(contactid)) {
          newAgentsList.push([...state.selectedAgents].find((a) => a.contact_id === contactid));
        }
      });
      return { ...state, selectedAgents: newAgentsList };
    }
    case 'SELECT_ALL_AGENTS': {
      const selectedAgents = [...state.selectedAgents];
      const allSelectedAgents = selectedAgents.concat(action.payload);
      const filtered = Array.from(new Set(allSelectedAgents.map((a) => a.contact_id)))
        .map((contactid) => (allSelectedAgents.find((a) => a.contact_id === contactid)));
      return { ...state, selectedAgents: filtered };
    }
    case 'REMOVE_SELECTED_AGENT': {
      const selectedAgents = [...state.selectedAgents];
      const filtered = selectedAgents.filter(
        (agent) => agent.contact_id !== action.payload.contact_id,
      );
      return { ...state, selectedAgents: filtered };
    }
    case 'SET_RECORD_BOOK': {
      const { recordBook, recordPageSize, recordPageCount } = action.payload;
      return {
        ...state,
        recordBook,
        recordPageSize,
        recordPageCount,
      };
    }
    case 'SET_RECORD_PAGE_IDX': {
      return {
        ...state,
        recordPageIdx: action.payload,
      };
    }
    case 'CLEAR_RECORD_BOOK': {
      return {
        ...state,
        recordBook: [],
        recordPageIdx: 0,
      };
    }
    case 'LOAD_AGENTS': {
      const users = action.users.map((user) => {
        // Check if this user already exists in records.
        const existing = state.records.find((agent) => agent.username === user.username);

        return {
          ...user,
          last_updated: moment(user.last_updated).format('MM-DD-YYYY H:mm:ss'),
          site: window.location.hostname.split('.').slice(-2).join('.'),
          // Preserve app state if user being refreshed.
          selected: existing ? existing.selected : false,
          visible: existing ? existing.visible : true,
        };
      });
      return { ...state, records: mapListSort(users, state.sortTerm) };
    }
    case 'UPDATE_AGENT_SELECTION': {
      const i = state.records.findIndex((agent) => agent.username === action.username);
      const records = [...state.records];
      records[i] = { ...state.records[i], selected: action.selected };
      return { ...state, records };
    }
    case 'TOGGLE_ALL': {
      const records = state.records.map((user) => ({ ...user, selected: action.checked }));
      return { ...state, records };
    }
    case 'SET_COLUMN_FILTER_VALUE': {
      const { id, value } = action.payload;
      const updatedColumnFilters = [];
      const tags = id.split('-'); // e.g. [ 'callinfo', 'duration' ]
      state.columnFilters.forEach((cf) => {
        if (cf.id.indexOf(id) !== -1
            || (!value && (cf.id === tags[0] && cf.id.indexOf('-') === -1))) {
          // 1. If user toggles on/off (callinfo), we flip all (callinfo-*)
          // 2. If user toggles off (callinfo-*), we flip (callinfo)
          updatedColumnFilters.push({ ...cf, value });

          // 3. If user toggles on (callinfo-*) AND all other (callinfo-*) are on,
          //    ensure that (callinfo) is also on.
          if (value && tags.length > 1) {
            const allChildrenToggledOn = state.columnFilters.filter((ocf) => {
              // Selecting all other nested column filters
              const hasSameParent = ocf.id.indexOf(tags[0]) !== -1;
              const isNestedTag = ocf.id.indexOf('-') !== -1;
              const isSameTag = ocf.id === id;
              return hasSameParent && isNestedTag && !isSameTag;
            });
            if (allChildrenToggledOn.every((c) => c.value === true)) {
              // Toggle parent column back on, which has already been added
              const parentIdx = updatedColumnFilters.findIndex((ucf) => ucf.id === tags[0]);
              updatedColumnFilters[parentIdx].value = value;
            }
          }
        } else {
          // 4. Not clicked, maintain state
          updatedColumnFilters.push(cf);
        }
      });
      return { ...state, columnFilters: updatedColumnFilters };
    }
    case 'TOGGLE_CALL_FILTER': {
      return { ...state, callFilterOpen: !state.callFilterOpen };
    }
    case 'FILTER': {
      const term = action.term.toLowerCase();
      const records = state.records.map((user) => {
        const matches = Object.values(user).filter((data) => {
          if (data && data.includes && data.toLowerCase) {
            return data.toLowerCase().includes(term);
          }
          return false;
        });
        return { ...user, visible: matches.length > 0 };
      });
      return { ...state, records };
    }
    case 'CLEAR':
      return {
        ...initialState,
        ...initialFilterState,
        columnFilters,
      };
    default:
      return state;
  }
};
